<div class="template3 " [class.open]="menuCollapsed" [ngStyle]="toogleJoinMenuDisplayCSS(menuCollapsed? true:false)" (keyup.esc)="onEscape()">
    <div class="mega-menu" slimScroll id="join-mega-menu-container" width="auto" size="3px" height="inherit"
        alwaysVisible="true" wheelStep="15" touchScrollStep="40">
        <!--TODO: removed due to transtion is not working [hidden]="!collapsed" -->
        <div class="row join-menu-block">
            <!-- category List -->
            <div class="col-12 col-sm-12 col-md-3 col-lg-3 mobile-padding">
                <div class="list-block category-section">
                    <input type="hidden" #joinmenutitle tabindex="-1"/>
                    <a class="title font-size-14 d-none d-md-block OpportunityTitle" tabindex="0">
                        {{'megamenu.The Forever Opportunity' |translate|translateKey}}
                    </a>
                    <ul class="list-unstyled my-md-3">
                        <!-- custom catalogs -->
                        <li>
                            <a class="d-none d-md-inline" tabindex="0"
                                (click)="navigateToJoinSite(joinNavPath.YOUROPPORTUNITY)"
                                attr.aria-label="{{'megamenu.Your Opportunity' }}">{{'megamenu.Your Opportunity' |translate|translateKey|titlecase}}</a>
                            <a class="d-block d-md-none category-link--mob"
                                (keyup.enter)="setCollapse(false,$event);navigateToJoinSite(joinNavPath.YOUROPPORTUNITY)"
                                (click)="setCollapse(false,$event);navigateToJoinSite(joinNavPath.YOUROPPORTUNITY)">
                                <span class="col p-0" tabindex="0"
                                    attr.aria-label="{{'megamenu.Your Opportunity' }}">
                                    {{'megamenu.Your Opportunity' |translate|translateKey}}</span>
                            </a>
                        </li>
                        <li>
                            <a class="d-none d-md-inline" tabindex="0"
                                (click)="navigateToJoinSite(joinNavPath.WHAT_IT_TAKES_TO_BE_A_FBO)"
                                attr.aria-label="{{'megamenu.What it takes to be a Forever Business Owner' |translate|translateKey}}">
                                {{'megamenu.What it takes to be a Forever Business Owner' |translate|translateKey}}</a>
                            <a class="d-block d-md-none category-link--mob"
                                (keyup.enter)="setCollapse(false,$event);navigateToJoinSite(joinNavPath.WHAT_IT_TAKES_TO_BE_A_FBO)"
                                (click)="setCollapse(false,$event);navigateToJoinSite(joinNavPath.WHAT_IT_TAKES_TO_BE_A_FBO)">
                                <span class="col p-0" tabindex="0"
                                    attr.aria-label="{{'megamenu.What it takes to be a Forever Business Owner' }}">
                                    {{'megamenu.What it takes to be a Forever Business Owner' |translate|translateKey}}</span>
                            </a>
                        </li>
                        <li>
                            <a class="d-none d-md-inline" tabindex="0"
                                attr.aria-label="{{'megamenu.Why Forever' | translate | translateKey }}"
                                (click)="navigateToJoinSite(joinNavPath.WHYFOREVER)">
                                {{'megamenu.Why Forever' |translate|translateKey }}?</a>
                            <a class="d-block d-md-none category-link--mob"
                                (keyup.enter)="setCollapse(false,$event);navigateToJoinSite(joinNavPath.WHYFOREVER)"
                                (click)="setCollapse(false,$event);navigateToJoinSite(joinNavPath.WHYFOREVER)">
                                <span class="col p-0" tabindex="0"
                                    attr.aria-label="{{'megamenu.Why Forever' }}">
                                    {{'megamenu.Why Forever' |translate|translateKey}}?</span>
                            </a>
                        </li>
                        <li>
                            <a class="d-none d-md-inline" tabindex="0" attr.aria-label="{{'megamenu.FAQ'}}"
                                (click)="navigateToJoinSite(joinNavPath.FAQPAGE)">
                                {{'megamenu.FAQ'|translate|translateKey}}</a>
                            <a class="d-block d-md-none category-link--mob"
                                (keyup.enter)="setCollapse(false,$event);navigateToJoinSite(joinNavPath.FAQPAGE)"
                                (click)="setCollapse(false,$event);navigateToJoinSite(joinNavPath.FAQPAGE)">
                                <span class="col p-0" tabindex="0" attr.aria-label="{{'megamenu.FAQ' }}">
                                    {{'megamenu.FAQ'|translate|translateKey}}</span>
                            </a>
                        </li>
                        <li>
                            <a class="d-none d-md-inline" (click)="gotoJoin(joinNavPath.WELCOME)">
                                {{'megamenu.Join'|translate|translateKey}}
                            </a>
                            <a class="d-block d-md-none category-link--mob"
                                (click)="setCollapse(false,$event);gotoJoin(joinNavPath.WELCOME);">
                                <span class="col p-0" tabindex="0" attr.aria-label="{{'megamenu.Join Our family'|translate  }}">
                                    {{'megamenu.Join' |translate|translateKey}}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- [class.d-block]="selectedBlock===2" -->
            <div class="col-12 col-sm-12 col-md col-lg d-none d-md-block main-block">
                <div class="list-block">
                    <a class="title font-size-14" [style.min-height.px]="joinmenutitle.offsetHeight" tabindex="0"
                        title="More About The Business"
                        attr.aria-label="{{'megamenu.More About The Business' |translate|translateKey}}">
                        {{'megamenu.More About The Business' |translate|translateKey}}
                    </a>
                    <div [attr.data-t-card]="'5'" appDynamicNavigation (isNavClicked)="navigateToPortal($event)"
                        id="card1" class="static-content">
                    </div>
                </div>
            </div>
            <div id="join-now-card-js" class="col-12 col-sm-12 col-md-auto col-lg-auto d-none d-md-block">
                <div class="list-block">
                    <a class="title font-size-14" [style.min-height.px]="joinmenutitle.offsetHeight"
                        title="Join Our Forever Family" tabindex="0"
                        attr.aria-label="{{'megamenu.Join Our Forever Family'|translate|translateKey}}">
                        {{'megamenu.Join Our Forever Family'|translate|translateKey}}
                    </a>
                    <div [attr.data-t-card]="'7'" appDynamicNavigation (isNavClicked)="navigateToPortal($event)"
                        id="card2" class="static-content card-240-360">
                    </div>
                </div>
            </div>
        </div>
    </div>